<template>
  <base-modal
    :is-visible="isVisible"
    @hideModal="hideModal()"
    :is-editable="false"
    :is-archivable="false"
    size="xl"
  >
    <template #header>
      {{ $t('routes.EXCMDeviceCreate') }}
    </template>
    <template #body>
      <create></create>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '@/components/BaseComponents/BaseModal'
import Create from '../Create'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'CreateModal',
  components: {
    BaseModal,
    Create
  },

  computed: {
    ...mapGetters({
      isVisible: 'excmdevice/createModal/isVisible',
      created: 'excmdevice/create/created'
    })
  },

  watch: {
    created (val) {
      if (val) {
        this.fetchDevices()
        this.hideModal()
      }
    }
  },

  methods: {
    hideModal () {
      this.reset()
      this.toggleModal()
    },
    ...mapActions({
      reset: 'excmdevice/create/reset',
      fetchDevices: 'excmdevice/list/default'
    }),
    ...mapMutations({
      toggleModal: 'excmdevice/createModal/toggleModal'
    })
  }
}
</script>

<style scoped>

</style>
